"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSentryClientOptions = void 0;
const common_1 = require("./common");
function getSentryClientOptions(dsn, themeName) {
    return (0, common_1.getCommonClientOptions)(dsn, themeName);
}
exports.getSentryClientOptions = getSentryClientOptions;
//# sourceMappingURL=client.js.map